import { useMemo } from 'react'
import { useSelector, shallowEqual } from 'react-redux'

import { Allowance } from './useReportAllowances'
import { DetailsGroup, useReportDetailsGroup } from './useReportDetailsGroup'


export type TotalsAllowancesAndFoodModesDto = {
  allowances: Record<Allowance, {
    Завтрак: number
    Обед: number
    Полдник: number
  }>
  totalCommon: number
  total: number
}

export function useReportTotalsAllowancesAndFoodModesDto() {
  const totals = useSelector((state: any) => state.reports.subsidies.data.totals, shallowEqual)
  const summary = useSelector((state: any) => state.reports.subsidies.data.summary, shallowEqual)
  const detailsGroup = useReportDetailsGroup()

  const res = useMemo(() => {
    if (totals && detailsGroup === DetailsGroup.ByAllowancesAndFoodModes && summary) {
      const { total, total_common: totalCommon } = summary
      return { ...totals, total, totalCommon } as TotalsAllowancesAndFoodModesDto
    }
    return null
  }, [totals, summary, detailsGroup])

  return res
}
